module.exports = __webpack_public_path__ + "img/icn_radio_hover.f0afc801.svg";